import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'calander',
  props: {
    weekList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    monthList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isAbTest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activeTab: 1,
      // 1 ：七日， 2：月度
      morePostUrlList: [],
      showList: [],
      // 展示的list
      list: []
    };
  },
  computed: {
    hideWeek: function hideWeek() {
      return this.weekList.length < 4;
    },
    hideMonth: function hideMonth() {
      return this.monthList.length < 4;
    }
  },
  watch: {
    activeTab: 'initList',
    weekList: 'initList',
    monthList: 'initList'
  },
  mounted: function mounted() {
    this.initList();
    var scrollEl = document.getElementById('calendar-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
  },
  methods: {
    initList: function initList() {
      var _this = this;

      this.$refs.calendarCon.scrollLeft = 0;

      if (this.activeTab === 1 && this.weekList.length >= 4) {
        this.list = this.weekList;
      } else {
        this.activeTab = 2;
        this.list = this.monthList;
      }

      if (this.list.length > 15) {
        // 铺开展示12个，第13个卡片展示为查看全部，图片为第13-16个项目海报拼出的四宫格
        this.showList = this.list.slice(0, 12).map(function (show) {
          return _this.initPrice(show);
        });
        var postList = this.list.slice(12, 16);
        this.morePostUrlList = postList.map(function (item) {
          return item.posterUrl;
        });
      } else {
        this.showList = _toConsumableArray(this.list.map(function (show) {
          return _this.initPrice(show);
        }));
      }
    },
    // 跳转日历页
    gotoCalendarPage: function gotoCalendarPage() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_bnzf3zsc_mc',
        cid: 'c_movie_aq5xt2v5',
        custom: {
          tab_id: 0
        }
      });
      this.go("/calendar?tab=".concat(this.activeTab));
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
          performanceId = _ref.performanceId,
          dataSeed = _ref.dataSeed;

      if (!performanceId) return;

      if (dataSeed) {
        window.seedAction(dataSeed);
      }

      this.go("/detail/".concat(performanceId), {
        _blank: true
      });
    },
    switchActiveTab: function switchActiveTab(tab) {
      this.activeTab = tab;
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_bnzf3zsc_mc',
        cid: 'c_movie_aq5xt2v5',
        custom: {
          tab_id: tab
        }
      });
    },
    initPrice: function initPrice(show) {
      if (show.priceRange && show.priceRange !== '价格待定') {
        var priceArr = show.priceRange.split('-');

        if (priceArr.length > 1) {
          show.showPriceSuffix = true;
        }
      }

      return show;
    }
  }
};